const React = require('react');
const { useState, useEffect, createContext } = React;
const { context } = require('app-context');
const LeaderboardNavigation = require('utils/leaderboardNavigation');

const LeaderContext = createContext({});

module.exports = function WeeklyLeaders({ user, schoolId, path, children }) {

    const scope = `${schoolId}:${user?.id}:${user?.roleId}`;
    const [data, setData] = useState(null);
    useEffect(() => {

        let current = true;
        let sequence = 0;
        const load = async () => {

            const request = ++sequence;
            try {
                const result = await context.api.nearpeer.gamification.decorations();
                if (current && sequence === request) {
                    LeaderboardNavigation.rememberRanks({ schoolId: Number(schoolId), userId: user.id, roleId: user.roleId }, 'weekly', result.enabled ? result.rows : []);
                    setData({ scope, ranks: result.enabled ? Object.fromEntries(result.rows.map(({ id, rank }) => [id, rank])) : {} });
                }
            }
            catch { if (current && sequence === request) { setData({ scope, ranks: {} }); } }
        };
        if (Number(schoolId) !== 240394 || user?.roleId !== 2) { return; }
        load();
        const timer = window.setInterval(load, 60000);
        const onParticipation = () => { LeaderboardNavigation.clearRanks({ schoolId: Number(schoolId), userId: user.id, roleId: user.roleId }); setData(null); load(); };
        window.addEventListener('gamification-participation', onParticipation);
        return () => {

            current = false;
            window.clearInterval(timer);
            window.removeEventListener('gamification-participation', onParticipation);
        };
    }, [scope, path]);
    return <LeaderContext.Provider value={data?.scope === scope ? data.ranks : {}}>{children}</LeaderContext.Provider>;
};

module.exports.LeaderContext = LeaderContext;
